export const ORDER_STATUS = {
  /** 用户创建-user_created、系统创建-system_created	创建订单	待支付*/
  TO_PAY: 0,
  /**用户关闭-user_closed、系统关闭-system_closed、超时关闭-timeout_closed、退款关闭-refund_closed	用户取消/未支付超时自动关闭	已关闭 */
  CLOSED: 2,
  /**异常 未知异常-uncatch_exception、发货异常-deliver_exception */
  ERROR: 4,
  /** 用户已支付-user_paid*/
  PAID: 5,
  /**已发货 物流发货-logistics_delivered、系统发货-system_delivered*/
  DELIVERING: 6,
  /**已完成  用户确认收货-user_completed、系统确认收货-system_completed、超时自动确认-timeout_completed */
  DONE: 7,
  /**售后 */
  SERVICING: 10,
};

export const orderStatusNames = [
  [ORDER_STATUS.TO_PAY, "待支付"],
  [ORDER_STATUS.CLOSED, "已关闭"],
  [ORDER_STATUS.ERROR, "异常"],
  [ORDER_STATUS.PAID, "已支付"],
  [ORDER_STATUS.DELIVERING, "已发货"],
  [ORDER_STATUS.DONE, "已完成"],
  [ORDER_STATUS.SERVICING, "售后中"],
];

export const ORDER_TYPE = {
  VIP: "vip",
  MATTING: "matting",
  PRINT: "print",
  WORK: "work",
  RECHARGE: "recharge",
  COUPON: "coupon",
  AGENT_VIP: "agent_vip",
  RIGHTS: "rights",
  COMPLEX: "complex",
  SERVICE: "service",
  REAL: "real",
};

export const orderTypeNames = [
  [ORDER_TYPE.VIP, "会员"],
  [ORDER_TYPE.MATTING, "抠图"],
  [ORDER_TYPE.PRINT, "印刷"],
  [ORDER_TYPE.WORK, "作品"],
  [ORDER_TYPE.RECHARGE, "充值"],
  [ORDER_TYPE.COUPON, "卡劵"],
  [ORDER_TYPE.AGENT_VIP, "代理会员"],
  [ORDER_TYPE.RIGHTS, "权益"],
  [ORDER_TYPE.COMPLEX, "复合"],
  [ORDER_TYPE.SERVICE, "定制服务"],
  [ORDER_TYPE.REAL, "实物"],
];

export const USER_RIGHT_STATUS = {
  NORMAL: 1,
  FROZEN: 2,
  RECYCLED: 3,
};
export const userRightStatusNames = [
  [USER_RIGHT_STATUS.NORMAL, "可用"],
  [USER_RIGHT_STATUS.FROZEN, "冻结"],
  [USER_RIGHT_STATUS.RECYCLED, "已回收"],
];

export const USER_RIGHT_FINAL_STATUS = {
  ...USER_RIGHT_STATUS,
  INVALID: 4,
  EXPIRED: 5,
  RUN_OUT: 6,
};
export const userRightFinalStatusNames = [
  ...userRightStatusNames,
  [USER_RIGHT_FINAL_STATUS.INVALID, "未开始"],
  [USER_RIGHT_FINAL_STATUS.EXPIRED, "已过期"],
  [USER_RIGHT_FINAL_STATUS.RUN_OUT, "已用完"],
];
/**授权主体权益code */
export const HUABAN_SUCAI_AUTHORIZED_SUBJECT =
  "HUABAN_SUCAI_AUTHORIZED_SUBJECT";

export const ORDER_STATUS_DESCRIPTION = {
  user_created: "用户创建",
  system_created: "系统创建",

  user_closed: "用户关闭",
  system_closed: "系统关闭",
  timeout_closed: "超时关闭",
  refund_closed: "退款关闭",
  uncatch_exception: "未知异常",
  deliver_exception: "发货异常",
  user_paid: "用户支付",
  logistics_delivered: "物流发货",
  system_delivered: "系统发货",
  user_completed: "用户确认收货",
  system_completed: "系统确认收货",
  timeout_completed: "超时自动确认",
};

export const INVOICE_STATUS = {
  TO_CREATE: 0,
  CREATED: 1,
  REFUSED: 2,
  CREATING: 3,
  FAILED: 4,
  SCRAPPED: 5,
  SCRAPPING: 6,
  SCRAP_FAILED: 7,
  TO_DELIVERY: 8,
  DELIVERED: 9,
};

export const invoiceStatusNames = [
  [INVOICE_STATUS.TO_CREATE, "待开票"],
  [INVOICE_STATUS.CREATED, "已开票"],
  [INVOICE_STATUS.REFUSED, "拒绝开票"],
  [INVOICE_STATUS.CREATING, "开票处理中"],
  [INVOICE_STATUS.FAILED, "开票失败"],
  [INVOICE_STATUS.SCRAPPED, "已作废"],
  [INVOICE_STATUS.SCRAPPING, "作废处理中"],
  [INVOICE_STATUS.SCRAP_FAILED, "作废失败"],
  [INVOICE_STATUS.TO_DELIVERY, "待寄送"],
  [INVOICE_STATUS.DELIVERED, "已寄送"],
];

// 购方类型
export const PAYER_TYPE = {
  PERSON: 1,
  COMPANY: 2,
};
export const payerTypeNames = [
  [PAYER_TYPE.PERSON, "个人"],
  [PAYER_TYPE.COMPANY, "企业"],
];

// 发票类型
export const TICKET_TYPE = {
  NORMAL: 1, // 普票
  SPECIAL: 2, // 增票
};
// 发票类型
export const TICKET_MODE = {
  PAPER: 0, // 纸质
  ELECTRONIC: 1, // 电子
};
export const ticketTypeNames = [
  [TICKET_TYPE.NORMAL, "电子普通发票"],
  [TICKET_TYPE.SPECIAL, "纸质增值税发票"],
];

/**订单优惠类型 */
export const PROMOTION_TYPE = {
  /** 会员升级抵扣 */
  upgrade: "trade.promotion",
  /** 抵扣，（升级时，有买增加次数的，会出现这个）*/
  tradeIn: "trade_in",
  /** 优惠券 */
  coupon: "coupon",
  /** 换购加购 */
  plus_buy: "activity.plus_buy",
  /**打折促销 */
  discount: "activity.promo",
};
